import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import MediumButton from "components/ProjectSpecificComponents/Elements/Global/atoms/Buttons/MediumButton"
import React from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router"

type Props = {
	mobileView?: boolean
}
const GoAdminButton = ({ mobileView }: Props) => {
	const history = useHistory()
	const formStore = useFormStore()
	const location = useLocation()

	const _onClick = () => history.push(ROUTES.REQUEST_CNFG)

	return (
		<MediumButton
			style={{
				color: mobileView
					? "var(--muddy-puddle-gray)"
					: formStore.settingsData.personalize.colorHeaderText ?? "var(--blue)",
				background: "none",
				fontSize: mobileView ? "12px" : "14px",
				fontWeight: mobileView ? 400 : 600,
			}}
			borderless
			onClick={_onClick}
			children={"Admin"}
		/>
	)
}

export default GoAdminButton
